import styled from 'styled-components';
import { breakpoints } from "../../../../../utils/styledBreakpoints";
import { Button } from 'devextreme-react/button';

export const BottomNavBarElement = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    background: #fff;
    height: 90px;
    padding: 0 30px;
    box-shadow: 0px 0px 6px 0px rgba(185, 186, 202, 0.33);
    z-index: 2;
`;

export const ButtongsGroup = styled.div`
    display: flex;
    gap: 1.4rem;
    ${breakpoints("gap", "rem", [{ 992: `0.75` }])};
    ${breakpoints("flex-basis", "%", [{ 992: `100` }])};
    ${breakpoints("justify-content", "", [{ 992: `space-between` }])};
`;

export const SummaryGroup = styled.div`
    display: flex;
    gap: 1.4rem;
    ${breakpoints("display", "", [{ 992: `none` }])};
`;

export const BottomButton = styled(Button)`
    min-width: 150px !important;
    min-height: 50px;
    padding: 0 25px;

    &:focus,
    &:active {
        border: 1px solid white;
        outline: 1px solid var(--button-primary-color);
    }

    &.dx-button-mode-outlined:focus,
    &.dx-button-mode-outlined:active {
        border: 1px solid white !important;
        outline: 1px solid var(--button-primary-color) !important;
        background: var(--button-primary-color) !important;
        color: var(--button-primary-text-color) !important;
    }

    &.dx-button-mode-outlined:focus .dx-button-text,
    &.dx-button-mode-outlined:active .dx-button-text {
        color: var(--button-primary-text-color) !important;
    }
`;